import axios from 'axios'
import router from '../router'
import store from '../store'
import { urlencode } from './common'

// 函数用于从 URL 中获取参数
function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}
// axios.defaults.withCredentials = true
axios.defaults.withCredentials = true
export function requestApi(reqUrl, type = 'POST', data = {}, auth = '', multipart = false) {
  if (!reqUrl) { return }
  
  // 检查 URL 中是否有 token 参数
  const urlToken = getQueryParam('token');
  if (urlToken) {
    // 缓存 token 到 Local Storage
    window.localStorage.setItem('token', urlToken);
  }

  let headers = {}
  let lang = JSON.parse(localStorage.getItem('lang')) || 'enus'
  data.lang = lang
  if (auth === 'member') {
    // if (typeof (store.state.member) === 'undefined' || !store.state.member.token) {
    //   router.push({ name: 'HomeLogin' })
    // }
    store.state.member.token = store.state.member.token || window.localStorage.getItem('token')
    headers['X-DS-KEY'] = store.state.member.token || window.localStorage.getItem('agent_token')
  }

  if (auth === 'distributor') {
    if (typeof (store.state.distributor) === 'undefined' || !store.state.distributor.token) {
      router.push({ name: 'DistributorLogin' })
    }
    headers['X-DS-KEY'] = store.state.distributor.token
  }
  if (auth === 'agent') {
    headers['X-DS-KEY'] = window.localStorage.getItem('agent_token')
  }
  if (auth === 'seller') {
    if (typeof (store.state.seller) === 'undefined' || !store.state.seller.token) {
      router.push({ name: 'HomeSellerLogin' })
    }
    headers['X-DS-KEY'] = store.state.seller.token
  }
  if (auth === 'chain') {
    if (typeof (store.state.chain) === 'undefined' || !store.state.chain.token) {
      router.push({ name: 'ChainLogin' })
    }
    headers['X-DS-KEY'] = store.state.chain.token
  }
  if (multipart) {
    headers['Content-Type'] = 'multipart/form-data'
  }
  const verifyToken = window.localStorage.getItem('gobuy_verify_token')
  if(verifyToken){
    headers['Verify-Token'] = verifyToken
  }
  type = type.toUpperCase()
  reqUrl = env.API_HOST + reqUrl
  let axiosData
  if (type === 'POST') {
    axiosData = {
      headers: headers,
      method: type,
      url: reqUrl,
      data: data
    }
  } else {
    if (JSON.stringify(data) !== '{}') {
      reqUrl += '?' + urlencode(data)
    }
    axiosData = {
      headers: headers,
      method: type,
      url: reqUrl
    }
  }
  return new Promise((resolve, reject) => {
    axios(axiosData).then(res => {
      if (res.data.code == 11002) {
        const domain = window.location.origin;
        if(!domain.includes('localhost')){
          window.location.href = '/cfs.html'
        }
      }
      
      if (res.data.code === 40001) {
        router.push({ name: 'ChainLogin', query: { clear: 1 } })// token过期，需要删除
      } else if (res.data.code === 11001) {
        const urlParams = new URLSearchParams(window.location.search);
        const is_iframe = urlParams.get('is_iframe') === '1';
        if(is_iframe){
          const currentDomain = window.location.origin;
				  let apiUrl = currentDomain.includes('localhost') ? 'https://www.dengshop.com' : currentDomain;
          window.top.location.href = apiUrl+'/home/memberlogin'
        }else{
          let hostname = env.SITE_URL;
          if(hostname.includes('trygobuy')){
            window.top.location.href = env.PRODUCT_URL
          }else{
            router.push({ name: 'HomeMemberLogin', query: { clear: 1 } })// token过期，需要删除
          }
        }
      } else if (res.data.code === 13001) {
        router.push({ name: 'HomeSellerLogin', query: { clear: 1 } })// token过期，需要删除
      } else if (res.data.code === 10000 || res.status) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    }, error => {
      reject(error)
    })
  })
}

export function requestRaw(reqUrl, type = 'POST', data = {}) {
  type = type.toUpperCase()
  let axiosData
  if (type === 'POST') {
    axiosData = {
      method: type,
      url: reqUrl,
      data: data
    }
  } else {
    if (JSON.stringify(data) !== '{}') {
      reqUrl += '?' + urlencode(data)
    }
    axiosData = {
      method: type,
      url: reqUrl
    }
  }
  return new Promise((resolve, reject) => {
    axios(axiosData).then(res => {
      resolve(res.data)
    }, error => {
      reject(error)
    })
  })
}
